<script setup>
import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

const getters = useStoreGetters();
const currentUser = computed(() => getters.getCurrentUser.value);

const greetingMessage = computed(() => {
  const hours = new Date().getHours();
  let period;
  if (hours < 12) {
    period = 'Bom dia';
  } else if (hours < 18) {
    period = 'Boa tarde';
  } else {
    period = 'Boa noite';
  }
  return { period, name: currentUser.value.name };
});
</script>

<template>
  <div
    class="min-h-screen flex items-center justify-center w-full font-inter"
  >
    <p
      class="text-3xl font-semibold text-n-slate-12 font-interDisplay tracking-[0.3px] text-center"
    >
      {{ greetingMessage.period }}, {{ greetingMessage.name }}. Bem-vindo a <span style="color: #22c55e;">SEGUE</span>.
    </p>
  </div>
</template>
